import { render, staticRenderFns } from "./OnHold.vue?vue&type=template&id=4ac2f5d2&"
import script from "./OnHold.vue?vue&type=script&lang=js&"
export * from "./OnHold.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "OnHold.vue"
export default component.exports